import styled, { keyframes } from 'styled-components'

const animateGlow = keyframes`
  0%{background-position:0% 50%}
  50%{background-position:100% 50%}
  100%{background-position:0% 50%}
`

export const ThankYouContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 64px;

  @media (max-width: 1100px) {
    flex-direction: column-reverse;
  }

  img {
    width: 291px;
    height: 331px;

    margin: 0 116px;
  }

  &::before {
    content: '';
    display: block;
    z-index: -1;

    position: absolute;
    bottom: 42%;
    left: 17%;

    width: 220px;
    height: 220px;

    animation: ${animateGlow} 7s ease-in-out infinite;
    background: linear-gradient(270deg, #08eddc, #09a8fa);
    background-size: 200% 200%;

    will-change: transform; // pre-optimizes for the blur filter
    filter: blur(166px);
  }

  @media (max-width: 1100px) {
    img {
      width: 159px;
      height: 181px;
    }

    &::before {
      left: 37%;
      bottom: 30%;

      width: 180px;
      height: 180px;
    }
  }

  @media (max-width: 791px) {
    &::before {
      left: 37%;
      bottom: 25%;
    }
  }

  @media (max-width: 533px) {
    .message-text {
      font-size: 20px;
      line-height: 30px;
    }
    .button-text {
      font-size: 16px;
    }
    &::before {
      left: 32%;
      bottom: 25%;
    }
  }
`

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 40px;

  max-width: 562.5px;

  background: linear-gradient(
    180deg,
    rgba(8, 237, 220, 0.1) 0%,
    rgba(8, 237, 220, 0.15) 50%,
    rgba(8, 237, 220, 0.1) 100%
  );

  padding: 40px 24px;
  border-radius: 32px;
`
